"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactDragDrawer = _interopRequireDefault(require("react-drag-drawer"));

var _IconActionClose = _interopRequireDefault(require("../Icons/IconActionClose"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  margin-top: 40px;\n  align-items: center;\n\n  > button {\n    margin: 0 10px;\n\n    &:first-of-type {\n      margin-left: 0;\n    }\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  z-index: 9999;\n  cursor: pointer;\n\n  &:hover {\n    svg > path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 30px 60px 22px;\n  border-bottom: 1px solid #ccc;\n  background-color: #fcfcfc;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 2.1rem;\n  line-height: 135%;\n  text-align: center;\n  letter-spacing: -0.03em;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  width: 550px;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  font-family: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  z-index: 9999999;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledModalActions = function StyledModalActions(_ref) {
  var children = _ref.children,
      position = _ref.position;
  return _react.default.createElement(ModalActions, {
    position: position
  }, children);
};

var Modal = function Modal(_ref2) {
  var title = _ref2.title,
      canClose = _ref2.canClose,
      children = _ref2.children,
      showModal = _ref2.showModal,
      setShowModal = _ref2.setShowModal,
      className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, ["title", "canClose", "children", "showModal", "setShowModal", "className"]);

  return _react.default.createElement(StyledDrawer, _extends({}, otherProps, {
    className: className,
    open: showModal,
    onRequestClose: canClose ? function () {
      return setShowModal(!showModal);
    } : ''
  }), _react.default.createElement(ModalContainer, null, canClose ? _react.default.createElement(ModalCloser, {
    onClick: function onClick() {
      return setShowModal(!showModal);
    }
  }, _react.default.createElement(_IconActionClose.default, {
    color: "#505050"
  })) : '', title ? _react.default.createElement(ModalTitleBar, null, title) : '', _react.default.createElement(ModalContent, {
    title: title
  }, children)));
};

var StyledDrawer = (0, _styledComponents.default)(_reactDragDrawer.default)(_templateObject());

var ModalContainer = _styledComponents.default.div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

var ModalTitleBar = _styledComponents.default.div(_templateObject3());

var ModalContent = _styledComponents.default.div(_templateObject4(), function (_ref4) {
  var title = _ref4.title;
  return title ? '30px' : '45px 30px 30px';
});

var ModalCloser = _styledComponents.default.a(_templateObject5(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

var ModalActions = _styledComponents.default.div(_templateObject6(), function (_ref6) {
  var position = _ref6.position;
  return handleActionsPosition(position);
});

var handleActionsPosition = function handleActionsPosition(position) {
  switch (position) {
    case 'left':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return 'flex-start';
  }
};

StyledModalActions.propTypes = {
  children: _propTypes.node,
  position: _propTypes.string
};
StyledModalActions.defaultProps = {
  position: 'right'
};
Modal.propTypes = {
  /** A title to be displayed at the top of the modal. */
  title: _propTypes.string,

  /** Set to true to make the modal closeable. */
  canClose: _propTypes.bool,
  children: _propTypes.node,
  showModal: _propTypes.bool,
  setShowModal: _propTypes.func.isRequired,
  className: _propTypes.string
};
Modal.defaultProps = {
  canClose: true,
  showModal: false
};
Modal.ModalActions = StyledModalActions;
Modal.ModalActions.displayName = 'Modal.ModalActions';
var _default = Modal;
exports.default = _default;